import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import isEmpty from 'lodash/isEmpty';
import {
  AccessTimeTwoTone,
  LocationOn
} from '@material-ui/icons';
import { generateImageSource } from '../../../../utils/generateImageSource';
import { jobPostingValidators } from '../../../../utils/validations';
import { tradeTypeIconMap } from '../../../../utils/constants';
import SkillBar from '../../../ProfileSearch/ProfileDetails/SkillBar/SkillBar.js';

const BusinessDetails = ({ editedJobPosting }) => {

  if (!isEmpty(editedJobPosting) && (jobPostingValidators.locationText(editedJobPosting)
    || jobPostingValidators.tradeType(editedJobPosting)
    || jobPostingValidators.yearsOfExperience(editedJobPosting)
    || jobPostingValidators.employmentType(editedJobPosting))) {
    return (
      <div className="create-job-posting__tooltip-section" data-testid="pro-tip-business-details">
        <p>
          When this job is active, we will recommended candidates who fit these characteristics:
        </p>
        {jobPostingValidators.employmentType(editedJobPosting)
          && (
            <p
              data-testid="job-posting-static-employmentType"
            >
              <span className="create-job-posting__tip-icon">
                <AccessTimeTwoTone />
              </span>
              {editedJobPosting.employmentType}
            </p>
          )}
        {jobPostingValidators.locationText(editedJobPosting)
          && (
            <p
              data-testid="job-posting-static-locationText"
              className="create-job-posting__business-detail-text"
            >
              <span className="create-job-posting__tip-icon">
                <LocationOn />
              </span>
              {editedJobPosting.locationText}
            </p>
          )}
        {jobPostingValidators.tradeType(editedJobPosting)
          && (
            <p>
              <Image
                src={generateImageSource(`/images/v1/path-to-pro/tradeTypes/${tradeTypeIconMap?.[editedJobPosting.tradeType] || 'residentialRemodeling'}.svg`)}
                className="create-job-posting__tip-icon"
                alt="trade icon"
                data-testid="tradeTypeIcon"
              />
              {editedJobPosting.tradeType}
            </p>
          )}
        {jobPostingValidators.yearsOfExperience(editedJobPosting)
          && (
            <p className="create-job-posting__business-detail-text">
              <SkillBar yearsOfExperience={editedJobPosting.yearsOfExperience} altStyle />
              {editedJobPosting.yearsOfExperience}
            </p>
          )}
      </div>
    );
  }
  return null;

};

export default BusinessDetails;